module.exports = __webpack_public_path__ + "img/BannerCV700X500px.0deb2856.jpg";